module.exports = __webpack_public_path__ + "img/p-sec01-img04.04cb365f.png";